import { useState, useEffect } from 'react';
import { apiGetBanks, apiGrossPayrollBaseUrl } from "config";
import axios from 'axios';

import { EnvironmentUrl, getUrl } from 'utils/environment';

const useBanks = (token) => {
    const [banks, setBanks] = useState([]);
    const [banksLoading, setBanksLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBanks = async () => {
            setBanksLoading(true);
            try {
                const res = await axios.get(`${apiGrossPayrollBaseUrl}${apiGetBanks}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (res?.data?.error === false) {
                    const url = getUrl();
                    if (url === EnvironmentUrl.EARNIPAY_PRODUCTION) {
                        setBanks(res?.data?.data);
                    } else {
                        setBanks(res?.data?.data?.content);
                    }
                }
            } catch (err) {
                setError('Error fetching banks');
            } finally {
                setBanksLoading(false);
            }
        };

        if (token) {
            fetchBanks();
        }
    }, [token]);
    
    return { banks, banksLoading, error };
};

export default useBanks;
